export const az = {
  title: 'İlkin Meşələr',
  subtitle: '30m, tropik, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'Funksiya',
      value: 'Bu məlumat dəsti 2001-ci ildə qlobal pantropik bölgələrdə əsas meşələrin miqyasını xəritələşdirir.',
    },
    {
      label: 'Qətmə',
      value: '30 × 30 metr',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Pantropik',
    },
    {
      label: 'Mənbə',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Braziliya, Konqo Demokratik Respublikası və İndoneziyada davam edən əsas meşə itkisi. Ətraf Mühitin Tədqiqi Məktubları, 13(7), s.074028.',
    },
    {
      label: 'Məzmun tarixi',
      value: 2001,
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'İbtidai meşələr çoxlu ekosistem xidmətləri təmin edən ən biomüxtəlif meşələr sırasındadır ki, bu da onları milli torpaqdan istifadənin planlaşdırılması və karbon uçotunun monitorinqi üçün vacib edir. Bu məlumat dəsti ilkin meşələri "yaxın tarixdə tamamilə təmizlənməmiş və yenidən böyüdülməmiş yetkin təbii rütubətli tropik meşə örtüyü" kimi müəyyən edir. Tədqiqatçılar Landsat şəkillərini hər bir bölgə üçün ayrıca alqoritmdən istifadə edərək ilkin meşə məlumatlarına təsnif etdilər.',
  },
  citation: {
    label: 'Sitat',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Braziliya, Konqo Demokratik Respublikası və İndoneziyada davam edən əsas meşə itkisi. Ətraf Mühitin Tədqiqi Məktubları, 13(7), s.074028. 31/01/2025-ci ildə Qlobal Meşə Nəzarəti vasitəsilə əldə edilib. www.globalforestwatch.org.',
  },
};
